(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/services/order-tickets-gift.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/services/order-tickets-gift.js');
"use strict";

const _svs$tur$pay = svs.tur.pay,
  accountServices = _svs$tur$pay.account_services,
  dialogs = _svs$tur$pay.dialogs;
const _svs$ticketsOrderHome = svs.ticketsOrderHome.utils,
  getConfirmPaymentOptions = _svs$ticketsOrderHome.getConfirmPaymentOptions,
  getAccountBalanceParams = _svs$ticketsOrderHome.getAccountBalanceParams,
  getLatestAccountBalance = _svs$ticketsOrderHome.getLatestAccountBalance;
function ticketsPriceSum(tickets) {
  return tickets.reduce((sum, _ref) => {
    let price = _ref.price,
      count = _ref.count;
    return sum + price * count;
  }, 0);
}
const createMailBoxPlayerOrderGiftRequest = _ref2 => {
  let tickets = _ref2.tickets,
    personalGreeting = _ref2.personalGreeting,
    message = _ref2.message,
    addressReferenceId = _ref2.addressReferenceId;
  return {
    referenceId: svs.utils.svsuid(),
    personalGreeting,
    message,
    addressReferenceId,
    orderItems: tickets.map(function () {
      let ticket = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return {
        productCode: parseInt(ticket.id, 10),
        quantity: ticket.count
      };
    })
  };
};
const orderTicketsHomeGift = async _ref3 => {
  let next = _ref3.next,
    requestParams = _ref3.requestParams;
  svs.ui.loader.show();
  const orderSummary = "Ordered (GIFT) ".concat(requestParams.tickets.map(_ref4 => {
    let id = _ref4.id,
      name = _ref4.name,
      count = _ref4.count;
    return "".concat(count, " st ").concat(name, "(").concat(id, ")");
  }).join(','));
  try {
    const request = createMailBoxPlayerOrderGiftRequest(requestParams);
    const _await$svs$tur$apiCal = await svs.tur.apiCaller.ticketgames.postMailboxGiftOrder({
        data: request
      }),
      response = _await$svs$tur$apiCal.response;
    svs.tur.pay.logger.info("".concat(orderSummary, " success"));
    next({
      response
    });
  } catch (e) {
    svs.tur.pay.logger.error("".concat(orderSummary, " failed: ").concat(e));
    next({
      error: e
    });
  }
  svs.ui.loader.hide();
};
function handleOrderTicketsGiftResult(_ref5) {
  let next = _ref5.next,
    error = _ref5.error;
  if (error) {
    svs.ticketsOrderHome.utils.showErrorMessage(error, next);
    throw error;
  } else {
    next();
  }
}
const orderTicketsGift = _ref6 => {
  let requestParams = _ref6.requestParams,
    onCancel = _ref6.onCancel,
    onDone = _ref6.onDone;
  const tickets = requestParams.tickets,
    afterPay = requestParams.afterPay;
  if (!(tickets !== null && tickets !== void 0 && tickets.length)) {
    return;
  }
  const priceSum = ticketsPriceSum(tickets) + svs.ticketsOrderHome.utils.constants.SHIPPING_COST;
  const isPayAfterDepositEnabled = svs.core.detect.feature('ft-tickets-pay-after-deposit');
  const totalCost = svs.utils.format.CurrencyFromJupiterString(priceSum);
  const shouldResolveAfterPay = isPayAfterDepositEnabled && afterPay;
  let accountBalance;
  let response;
  let error;
  let latestAccountBalance;
  const calls = [{
    fn: accountServices.playerSuspension
  }, {
    in: () => ({
      spelpausFlags: [accountServices.playerSpelpaus.CONSTANTS.ALL, accountServices.playerSpelpaus.CONSTANTS.QUICK_GAMES]
    }),
    fn: accountServices.playerSpelpaus
  }, {
    fn: accountServices.dayTimeLimit
  }, {
    in: () => getAccountBalanceParams({
      isPayAfterDepositEnabled,
      price: totalCost
    }),
    fn: accountServices.accountBalance,
    out: args => {
      var _args = args;
      accountBalance = _args.accountBalance;
      return _args;
    }
  }, {
    fn: accountServices.playerDepositLimits
  }, {
    in: () => getConfirmPaymentOptions({
      price: totalCost,
      accountBalance
    }),
    fn: shouldResolveAfterPay ? _ref7 => {
      let next = _ref7.next;
      return next();
    } : dialogs.confirmPayment
  }, {
    in: () => ({
      requestParams
    }),
    fn: orderTicketsHomeGift,
    out: args => {
      var _args2 = args;
      response = _args2.response;
      error = _args2.error;
      return _args2;
    }
  }, {
    in: () => ({
      response,
      error
    }),
    fn: handleOrderTicketsGiftResult
  }, {
    fn: getLatestAccountBalance,
    out: args => {
      var _args3 = args;
      latestAccountBalance = _args3.latestAccountBalance;
      return _args3;
    }
  }, {
    in: () => ({
      price: totalCost,
      accountBalance: latestAccountBalance !== null && latestAccountBalance !== void 0 ? latestAccountBalance : accountBalance
    }),
    fn: shouldResolveAfterPay ? svs.ticketsOrderHome.components.afterPaymentDialog : _ref8 => {
      let next = _ref8.next;
      return next();
    }
  }];
  const cancel = () => {
    onCancel === null || onCancel === void 0 || onCancel();
  };
  const done = () => {
    onDone === null || onDone === void 0 || onDone({
      response,
      error
    });
  };
  svs.tur.pay.initPay({
    calls,
    cancel,
    done,
    shouldDisplayGeneralError: false
  });
};
setGlobal('svs.ticketsOrderHome.services.orderTicketsGift', orderTicketsGift);

 })(window);